<template>
    <p-secure :require-role="[SECURITYROLES.STOREMANAGER]">
        <div>
            <p-card>
                <b-row cols-sm="2"  cols="1" cols-xl="4" class="mt-3 ms-1 me-2">
                    <b-col>
                        <p-input label="Account Number"
                                 v-model="customer.number"
                                 readonly />
                    </b-col>
                    <b-col>
                        <p-input label="Student ID"
                                 v-model="customer.studentAccount"
                                 readonly />
                    </b-col>

                    <b-col>
                        <p-input label="First Name"
                                 v-model="customer.firstName"
                                 readonly />
                    </b-col>
                    <b-col>
                        <p-input label="Last Name"
                                 v-model="customer.lastName"
                                 readonly />
                    </b-col>
                </b-row>
                <p-search-table api-destination="customers"
                                :filters="filters"
                                sort-by="transactionDate"
                                :fields="fields"
                                search-destination="searchTransactionHistory"
                                :enable-row-selection="false"
                                :sort-desc="true">
                    <template v-slot:cell(view)="{ value, item }">
                        <b-button variant="outline-primary" size="sm" @click='getTransaction(item)' v-b-modal.customerTransactionModal>View</b-button>
                    </template>
                </p-search-table>

            </p-card>
        </div>
        <TransactionDetailModal :transaction="selectedTransaction" @closed="cancelGetTransaction" />
    </p-secure>
</template>

<script>
    import { datetimeToLocalTimeFormatter, currencyFormatter } from '../../components/Common/Formatters.js';
    import TransactionDetailModal from '../../components/TransactionDetailModal.vue';
    import axios from 'axios';

    export default {
        props: {
            customer: [Object],
        },
        data() {
            return {
                selectedTransaction: null,
                filters: {
                    automatic: "",
                    searchBy: 'All',
                    customerId: 0,
                    options: [
                        'All',
                        'Transaction ID',
                        'Store',
                        'POS Device',
                        'Cashier',
                        'SKU',
                        'Description',
                        'Serial #'
                    ]
                },
                fields: [
                    {
                        key: 'view',
                        label: '',
                        class: 'tcw100'
                    },
                    {
                        label: 'Transaction ID',
                        key: 'transactionId',
                        sortable: true
                    },
                    {
                        label: 'Date & Time',
                        key: 'transactionDate',
                        sortable: true,
                        formatter: datetimeToLocalTimeFormatter
                    },
                    {
                        label: 'Location',
                        key: 'transactionLocationName',
                        sortable: true
                    },
                    {
                        label: 'POS Device Name',
                        key: 'transactionPOSDeviceName',
                        sortable: true
                    },
                    {
                        label: 'Cashier',
                        key: 'transactionCashier',
                        sortable: true
                    },
                    {
                        label: 'Transaction Type',
                        key: 'transactionType',
                        // Sale / Refund / Pay In / Pay Out / Rented / Rental Check In, joined server-side after
                        // paging. Not sortable for that reason: the value does not exist to sort on in SQL.
                        sortable: false
                    },
                    {
                        label: 'Total',
                        key: 'transactionTotal',
                        sortable: true,
                        tdClass: 'text-end',
                        formatter: currencyFormatter
                    }
                ]
            };
        },
        methods:
        {
            getTransaction(transaction) {
                // Cancel any earlier in-flight fetch so a stale response can't
                // populate the modal after the user already moved on.
                this.cancelGetTransaction();
                this.selectedTransaction = null;
                this.transactionAbortController = new AbortController();
                const controller = this.transactionAbortController;
                axios.get("customers/getTransaction", {
                        params: { saleFulfillmentId: transaction.saleFulfillmentId },
                        signal: controller.signal
                    })
                    .then(resp => {
                        if (controller.signal.aborted) return;
                        this.selectedTransaction = resp.data;
                        this.$bvModal.show("customerTransactionModal");
                    })
                    .catch(err => {
                        if (axios.isCancel?.(err) || err?.name === 'CanceledError') return;
                        throw err;
                    });
            },
            cancelGetTransaction() {
                this.transactionAbortController?.abort();
                this.transactionAbortController = null;
            }
        },
        created: function () {

            this.filters.customerId = this.customer.customerId;

        },
        components: {
            TransactionDetailModal
        }

    };
</script>
